export { initializeMetaAPI } from './initialize';

export type { MetaAPI } from './types';



// WEBPACK FOOTER //
// ../../../../src/api/meta/index.ts